import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ECookiesActionTypes {
  CookiesAccepted = 'cookies/cookiesAccepted',
}

export type TCookiesAccepted = ITypedReduxAction<ECookiesActionTypes.CookiesAccepted>;

export type TCookiesActions = TCookiesAccepted;
